import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from '../../core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import ResetPasswordConfirmed from '../../estimations/events/ResetPasswordConfirmed';
import ResetPasswordDone from '../../estimations/events/ResetPasswordDone';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(ResetPasswordConfirmed.type),
        mergeMap((confirmed: ResetPasswordConfirmed) =>
            backend.get(`${api()}customers/` + confirmed.customerId + '/reset').pipe(
                map((e: AjaxResponse) => new ResetPasswordDone(e.response.password)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            )
        )
    );



// WEBPACK FOOTER //
// ./src/application/admin/epic/resetPassword.ts